import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FooterContext } from "@insite/content-library/Pages/Footer";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: BottomFooterContainerStyles;
}

export interface BottomFooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    socialGridItem?: GridItemProps;
}

export const bottomFooterContainerStyles: BottomFooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            margin: auto;
            padding-bottom: 30px;
        `,
    },
    logoGridItem: {
        width: [12, 8, 6, 8, 8],
    },
    socialGridItem: {
        width: [12, 4, 6, 4, 4],
        css: css`
            @media print {
                display: none !important;
            }
        `,
    },
};

const BottomFooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(bottomFooterContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.logoGridItem} align="middle">
                <Zone zoneName="LogoGrid" contentId={id} />
            </GridItem>
            <GridItem {...styles.socialGridItem}>
                <Zone zoneName="SocialGrid" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const bottomFooterContainer: WidgetModule = {
    component: BottomFooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default bottomFooterContainer;
